/* eslint-disable react/prop-types */
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './button-nav-main-desj.module.css';
import Tooltip from "@mui/material/Tooltip";
import Fade from "@mui/material/Fade";

const ButtonNavMainDesj = ({ isActive }) => {
  const navigate = useNavigate();

  const onButtonNavMainClick = useCallback(() => {
    navigate('/design-journey');
  }, [navigate]);

  return (
    <Tooltip
      className={styles.tooltip}
      title="Journal"
      placement="top-start"
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 200 }}
      id="tooltip-mainmenu"
      slotProps={{
        popper: {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [30, -8],
              },
            },
          ],
        },
      }}
    >
      <button
        className={`${styles.buttonNavmain} ${isActive ? styles.active : ""}`}
        id="DesjourButton"
        onClick={onButtonNavMainClick}
      >
        <img
          className={styles.bubblesubtract01Icon}
          alt="svg"
          id="bubble-subract-descjour"
          src="/dark/assets/imgs/nav/bubblesubtract01.svg"
        />
        <img
          className={styles.icondesjour}
          alt="icon"
          id="icon-desjour"
          src="/dark/assets/imgs/nav/icondesjour.svg"
        />
      </button>
    </Tooltip>
  );
};

export default ButtonNavMainDesj;
